import { css } from '@emotion/react';
import { tokens, applyFont, media } from '@domain-group/fe-brary';

const { typography } = tokens;

export const rmaContainer = css`
  ${applyFont(typography.body)}
  color: ${tokens.colors.neutral.medium.default};
  ${media('<=tablet')} {
    margin-top: ${tokens.spacing.s};
  }
`;

export const allReviews = css`
  ${applyFont(typography.mini)}
  color: ${tokens.colors.neutral.medium.default};
`;

export const showAllContainer = css`
  ${media('<=tablet')} {
    width: 100%;
  }
`;

export const rmaLogo = css`
  ${media('<=tablet')} {
    margin-right: ${tokens.spacing.s};
  }
`;

export const viewAllButton = css`
  color: ${tokens.colors.neutral.heavy.default};
  :hover,
  :focus,
  :active {
    color: ${tokens.colors.neutral.heavy.default};
  }
`;
